import rwererwrReact, { useState } from "react";
import { observer } from "mobx-react-lite";
import { classNames, htmlValidation, useStore } from "../../helpers";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export const FTRFilterPane = observer((props) => {
    // @ts-ignore
    const { surveys, onSearch, tags } = props;
    const { surveyResponseStore } = useStore();
    const [query, setQuery] = useState("");

    return (
        <div className="flex flex-row flex-wrap">
            <div className="mb-2 flex w-9/12 lg:w-7/12">
                <Autocomplete
                    freeSolo
                    className="z-0 w-full rounded"
                    id="select-user"
                    style={{ backgroundColor: "white" }}
                    options={tags}
                    onChange={(event, v) => {
                        htmlValidation(event);
                        // @ts-ignore
                        setQuery(v ?? "");
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Search..."
                            onChange={(event) => {
                                htmlValidation(event);
                                setQuery(event.target.value);
                            }}
                            inputProps={{
                                ...params.inputProps,
                                type: "search",
                            }}
                        />
                    )}
                />
                {/*<input type="search" value={query} onChange={(evt) => {*/}
                {/*    setQuery(evt.target.value);*/}
                {/*}} className="w-full h-10 pr-10 pl-4 rounded z-0 focus:shadow focus:outline-none"*/}
                {/*       placeholder="Search..."/>*/}
            </div>
            <div className="flex w-3/12 flex-row items-center justify-around lg:w-1/12">
                <div
                    className="cursor-pointer"
                    onClick={() => {
                        onSearch(query?.trim() || "");
                    }}
                >
                    <i className="fa fa-search z-20 text-2xl text-gray-400 hover:text-purple-500" />
                </div>
                <div
                    className="cursor-pointer"
                    onClick={() => {
                        surveyResponseStore.set_search_highlights(!surveyResponseStore.searchHighlights);
                    }}
                >
                    <i
                        key={`search_highlights_${surveyResponseStore.searchHighlights}`}
                        className={classNames(
                            surveyResponseStore.searchHighlights
                                ? "fa-solid fa-star text-yellow-300"
                                : "fa-regular fa-star",
                            "text-2xl"
                        )}
                        title="Contains Important Highlights"
                    />
                </div>
            </div>
            <div className="mb-2 w-full lg:w-4/12">
                <select
                    className="z-0 w-full rounded p-2 outline-none focus:shadow sm:p-4"
                    style={{ backgroundColor: "white" }}
                    onChange={(eve) => {
                        const id = parseInt(eve.target.value);
                        surveyResponseStore.setActiveSurveyId(id);
                    }}
                >
                    {surveys.map((survey) => {
                        if (!survey) return;
                        return (
                            <option className="text-md p-2" value={survey.id}>
                                {survey.name}
                            </option>
                        );
                    })}
                </select>
            </div>
        </div>
    );
});
